import { useSearchParams } from 'react-router-dom';

/**
 * Safe wrapper around useSearchParams that checks if we're in a Router context.
 * The try/catch is intentional: a component is either in a Router or not, so the
 * branch is stable across renders and hook call order is consistent.
 */
export function useRouterSafe() {
    try {
        // oxlint-disable-next-line react-hooks/rules-of-hooks -- stable branch: component is always in/out of Router
        const [searchParams, setSearchParams] = useSearchParams();
        return { searchParams, setSearchParams, isInRouterContext: true as const };
    } catch {
        const searchParams = new URLSearchParams();
        const setSearchParams = () => {};
        return { searchParams, setSearchParams, isInRouterContext: false as const };
    }
}
